import moment from "moment";
import momentTz from "moment-timezone";

const AUD = new Intl.NumberFormat('en-AU', {
  style: 'currency',
  currency: 'AUD',
});

export const getISODate = (date) => {
  return moment(date).toISOString();
}

export function getFormattedDateTime(data) {
  return momentTz(data)
    .tz("Australia/Brisbane")
    .format("DD-MM-YYYY H:mm:ss");
}

export function getFormattedDateTimeV2(date) {
  return momentTz(date)
    .tz("Australia/Brisbane")
    .format();
}

export function getFormattedDate(data, formt = "DD-MM-YYYY") {
  return momentTz(data)
    .tz("Australia/Brisbane")
    .format(formt);
}

export function getFormattedTime(data) {
  return momentTz(data)
    .tz("Australia/Brisbane")
    .format("H:mm:ss");
}

export function getFormattedTimeV2(data) {
  return momentTz(data)
    .tz("Australia/Brisbane")
    .format("H:mm");
}

export function getFormattedMonthDate(date) {
  if (!date) return "";

  let da = date.split("-");
  if (da.length < 3) return "";

  da[0] = parseInt(da[0]);
  da[1] = parseInt(da[1]) - 1;
  da[2] = parseInt(da[2]);

  let dt = new Date(da[2], da[1], da[0]);

  return moment(dt)
    .format("Do MMM YYYY")
    .toString();
}

export function getFormattedMonthDateV2(date) {
  return moment(date, "DD-MM-YYYY");
}

export function getFormattedMonthDateV3(date) {
  return moment(date)
    .format("Do MMM YYYY")
    .toString();
}

export function getCurrDateInMoment() {
  return moment(new Date());
}

export function getCurrDateInMomentV2() {
  return momentTz(new Date()).tz("Australia/Brisbane");
}

export function converToUtc(date) {
  let dt = moment(date);
  return new Date(
    dt.get("year"),
    dt.get("month"),
    dt.get("date"),
    0,
    0,
    0
  ).toISOString();
}

// convert your date to brisbane time for searching function as backend will only use ISO date directly
export function convertToBrisbaneTimeWithStartDay(date) {
  const startDayDate = momentTz(date).tz("Australia/Brisbane").startOf('day').toISOString();
  return startDayDate;
}

export function convertToBrisbaneTimeWithEndDay(date) {
  return momentTz(date).tz("Australia/Brisbane").endOf('day').toISOString();
}

export function getWeekDay(date) {
  return momentTz(date)
    .tz("Australia/Brisbane")
    .format("dddd");
}

export function convertToMomentDateTime(date) {
  return moment(date);
}

export function getFutureDateByDays(days, date = new Date()) {
  return momentTz(date)
    .add(days, "day")
    .tz("Australia/Brisbane");
}

export function getPastDateByDays(days, date = new Date()) {
  return momentTz(date)
    .subtract(days, "day")
    .tz("Australia/Brisbane");
}

export function getDayMonthYearFromISOString(date = new Date().toISOString()) {
  const dateArr = date.split("T");
  if (!dateArr || dateArr.length < 1) return "";
  const dateInfo = dateArr[0];
  const dateInfoArr = dateInfo.split("-");
  if (!dateInfoArr || dateInfoArr.length < 3) return "";
  const [year, month, day] = dateInfoArr;
  const newDate = `${day}-${month}-${year}`;
  return newDate;
}

export function getDoctorWillCallYouCustomText(selectedDate) {
  if (selectedDate) {
    selectedDate = moment(selectedDate);
    const selectedContactDateByPatient = selectedDate.format("DD/MM/YYYY");
    const selectedContactDayByPatient = selectedDate.format("dddd");
    const selectedTime = selectedDate.format("h:mm a").replace(" ", "");
    const patientSelectedEndTime = selectedDate
      .add(2, "hours")
      .format("h:mm a")
      .replace(" ", "");
    return `${selectedContactDayByPatient} ${selectedContactDateByPatient} between ${selectedTime} and ${patientSelectedEndTime}`;
  }
  return "-";
}

export function getAgeByYears(date) {
  let da = date.split("-");
  da[0] = parseInt(da[0]);
  da[1] = parseInt(da[1]) - 1;
  da[2] = parseInt(da[2]);

  let dt = new Date(da[2], da[1], da[0]);
  let years = moment().diff(dt, 'years');
    return years;
}

export function getFormattedTimeOnly(date) {
  let date_future = new Date();
  let passedDate = new Date(date);

  let seconds = Math.floor((date_future - (passedDate)) / 1000);
  let minutes = Math.floor(seconds / 60);
  let hours = Math.floor(minutes / 60);
  let days = Math.floor(hours / 24);

  hours = hours - (days * 24);
  minutes = minutes - (days * 24 * 60) - (hours * 60);
  seconds = seconds - (days * 24 * 60 * 60) - (hours * 60 * 60) - (minutes * 60);

  hours = (hours).toString().padStart(2, 0);
  minutes = (minutes).toString().padStart(2, 0);
  seconds = (seconds).toString().padStart(2, 0);
  return moment(`${hours}:${minutes}:${seconds}`, 'HH:mm:ss').format('HH:mm:ss');
}

export function incrementSecond(date) {
  return moment(date, "HH:mm:ss").add(1, 'second').format("HH:mm:ss");
}

export function isAfterToday(isoDate, format) {
  return moment().isAfter(moment(isoDate, format));
}

export const getMomentObjFormatterWithTimeZone = (date, formatter) => {
  return  momentTz(date, formatter)
    .tz("Australia/Brisbane");
}

export function getDateDiffFromTodayInDays(startDate, format = "YYYY-MM-DD hh:mm:ss") {
  return moment(startDate, format).diff(moment(), "days");
}

export function getFormattedMoney(amount) {
  return AUD.format(amount);
}

export const getCurrentMonthAndYear = () => {
  return {
    month: moment().month(),
    year: moment().year()
  }
};

// moment month number starts from 0
export const getNextMonthFrom = (momentMonthNumber) => {
  const selectedMonthYear = moment().month(momentMonthNumber.month).year(momentMonthNumber.year).add(1, 'month');
  let dataToSendBack = {
    month: selectedMonthYear.get('month'),
    year: selectedMonthYear.get('year'),
  }
  return dataToSendBack;
};

// moment month number starts from 0
export const getPreviousMonthFrom = (momentMonthNumber) => {
  const selectedMonthYear = moment().month(momentMonthNumber.month).year(momentMonthNumber.year).subtract(1, 'month');
  let dataToSendBack = {
    month: selectedMonthYear.get('month'),
    year: selectedMonthYear.get('year'),
  }
  return dataToSendBack;
};

export const getCalendarDatesByMonthStartingThisWeek = (startingDate) => {
  const startOfMonth = startingDate ? moment(startingDate):
    moment().startOf('week').add(1, 'day');
  const endOfMonth = moment(startOfMonth).add(4, 'weeks');

  // Create an array to store the dates for each week of the month
  const calendar = [];

  // Loop through each week of the month and push the dates to the calendar array
  while (startOfMonth.isBefore(endOfMonth)) {
    let week = [];
    for (let i = 0; i < 7; i++) {
      // week.push(startOfMonth.format('D'));
      week.push({
        date: startOfMonth.format("DD/MM/YYYY"),
        day: startOfMonth.format("ddd").toUpperCase()
      })
      startOfMonth.add(1, 'day');
    }
    calendar.push(week);
  }

  return calendar;
}

// this function will always start the dates from MONDAY
export const getCalendarDatesByMonth = (preSelectedMonth, preSelectedYear) => {

  let selectedMonth = preSelectedMonth != undefined ? preSelectedMonth : moment().month();
  let selectedYear = preSelectedYear != undefined ? preSelectedYear : moment().year();

  // Set the start date of the calendar to the first Monday of the month
  let startOfMonth = moment().month(selectedMonth).year(selectedYear).startOf('month').startOf('week').add(1, 'day');

  // Set the end date of the calendar to the last Sunday of the month
  let endOfMonth = moment().month(selectedMonth).year(selectedYear).endOf('month').endOf('week').subtract(1, 'day');

  // Create an array to store the dates for each week of the month
  let calendar = [];

  // Loop through each week of the month and push the dates to the calendar array
  while (startOfMonth.isBefore(endOfMonth)) {
    let week = [];
    for (let i = 0; i < 7; i++) {
      // week.push(startOfMonth.format('D'));
      week.push({
        date: startOfMonth.format("DD/MM/YYYY"),
        day: startOfMonth.format("ddd").toUpperCase()
      })
      startOfMonth.add(1, 'day');
    }
    calendar.push(week);
  }

  return calendar;
}

export const mergeDateAndTimeUsingMomentObj = (dateMomentObj, timeMomentObj) => {
  const dateString = dateMomentObj.format("DD/MM/YYYY");
  const timeString = timeMomentObj.format("h:mm a");
  console.log("Date String: ", dateString, "Time String: ", timeString);

  // Combine the date and time into a single string
  const dateTimeString = `${dateString} ${timeString}`;

  // Parse the combined string into a moment object, assuming the local timezone.
  const localDateTime = moment(dateTimeString, "DD/MM/YYYY h:mm a");

  // Convert the local time to Brisbane time without changing the actual time value.
  const dateInBrisbane = localDateTime.tz("Australia/Brisbane", true).toISOString();

  return dateInBrisbane;
}

export const getMomentObjFormmaterWithTimeZone = (date, formatter) => {
  const formmatedMomentObj = momentTz(date, formatter)
    .tz("Australia/Brisbane");
  return formmatedMomentObj;
}

export function getFormattedTimeWithTimeZone(isoDate, timeZone = "Australia/Brisbane") {
  return momentTz(isoDate)
    .tz(timeZone)
    .format("h:mm a");
}

export function getFormattedTimeWithTimeZoneCapital(isoDate, timeZone = "Australia/Brisbane") {
  return momentTz(isoDate)
    .tz(timeZone)
    .format("h:mmA");
}

export function getFormatedISODateWithTimeZone(date, timeZone = "Australia/Brisbane") {
  const momentDate = momentTz(date).tz(timeZone);
  return momentDate.toISOString();
}

export function getFormattedDateHoursWithTimeZone(isoDate, timeZone = "Australia/Brisbane") {
  const dateHours = momentTz(isoDate).tz(timeZone).format("DD/MM/YYYY h:mm a");
  return dateHours;
}
